(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const sectionId = '{{ section.id }}';
  let soldOutObserver;
  let soldOutFrame;

  const organiseSoldOutProducts = () => {
    const resultsList = document.querySelector(`results-list[section-id="${sectionId}"]`);
    if (!resultsList) return;

    if (soldOutObserver) soldOutObserver.disconnect();

    const cards = Array.from(resultsList.querySelectorAll('[data-stock-state]'));
    const parents = [...new Set(cards.map((card) => card.parentElement).filter(Boolean))];

    parents.forEach((parent) => {
      const directCards = Array.from(parent.children).filter((item) => item.matches?.('[data-stock-state]'));
      const availableCards = directCards.filter((item) => item.dataset.stockState === 'available');
      const soldOutCards = directCards.filter((item) => item.dataset.stockState === 'sold-out');
      let heading = Array.from(parent.children).find((item) => item.classList?.contains('sold-out-section-heading'));

      if (!soldOutCards.length) {
        heading?.remove();
        return;
      }

      if (!heading) {
        heading = document.createElement('li');
        heading.className = 'sold-out-section-heading';
        heading.setAttribute('aria-label', 'Sold Out');
        heading.innerHTML = `
          <div class="sold-out-section-heading__inner">
            <p class="sold-out-section-heading__eyebrow">ARCHIVE</p>
            <h2 class="sold-out-section-heading__title">SOLD OUT</h2>
            <p class="sold-out-section-heading__text">Gone for now — but worth remembering.</p>
          </div>`;
      }

      availableCards.forEach((card) => parent.appendChild(card));
      parent.appendChild(heading);
      soldOutCards.forEach((card) => parent.appendChild(card));
    });

    const currentResultsList = document.querySelector(`results-list[section-id="${sectionId}"]`);
    if (currentResultsList && soldOutObserver) {
      soldOutObserver.observe(currentResultsList, { childList: true, subtree: true });
    }
  };

  const scheduleSoldOutOrganisation = () => {
    cancelAnimationFrame(soldOutFrame);
    soldOutFrame = requestAnimationFrame(organiseSoldOutProducts);
  };

  const initialiseSoldOutOrganisation = () => {
    const resultsList = document.querySelector(`results-list[section-id="${sectionId}"]`);
    if (!resultsList) return;

    soldOutObserver = new MutationObserver(scheduleSoldOutOrganisation);
    soldOutObserver.observe(resultsList, { childList: true, subtree: true });
    organiseSoldOutProducts();
  };

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseSoldOutOrganisation, { once: true });
  } else {
    initialiseSoldOutOrganisation();
  }

  document.addEventListener('shopify:section:load', scheduleSoldOutOrganisation);

  } catch(e) { console.error(e); }
})();
})();
